import React, { useState } from 'react';
import { Grid } from '../../../shared/grid';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Autocomplete, Chip, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import '../Download.scss';
import { useFormikContext } from 'formik';
import { VirtualizedListBox } from '../FireDanger';
type ScrollCtxValue ={
    scrollTopRef: React.MutableRefObject<number>;
    restoreToken: number;
};

const ScrollCtx = React.createContext<ScrollCtxValue | null>(null);

type StationInfoProps = {
    stationInfoParams: any,
    clearSelected: any,

}


export const StationInformation: React.FC<StationInfoProps> = ({stationInfoParams, clearSelected}) => {
    const { values, errors, touched, setFieldTouched} = useFormikContext<any>();
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [filteredStations, setFilteredStations] = useState<any[]>([]);
    const [inputValue, setInputValue] = useState('');
    const [restoreToken, setRestoreToken] = useState(0)
    const scrollTopRef = React.useRef(0);

    return (
        <div>
            <Grid row desktop={{ col: 6 }}>
                <label id='dataFormat'>Data Format <span className='required'>Required</span>
                    <Select
                        displayEmpty
                        renderValue={stationInfoParams.values.dataFormat !== "" ? undefined : () => "Select a Data Format"}
                        labelId='dataFormat'
                        name="dataFormat"
                        onBlur={()=>stationInfoParams.setFieldTouched('dataFormat')}
                        error={!!stationInfoParams.errors.dataFormat && !!stationInfoParams.touched.dataFormat }                        
                        className="dataDownload"
                        onChange={stationInfoParams.setDataFormat}
                        label="Select Data Format"
                        value={stationInfoParams.values.dataFormat}
                        aria-disabled={stationInfoParams.values.dataSubject === '' && stationInfoParams.values.dataSet === ''}
                    >
                        {
                            <MenuItem value="csv" key="csv-station">CSV</MenuItem>   
                        }
                    </Select>
                </label>
                <span style={{color: '#d32f2f'}}>{stationInfoParams.errors.dataFormat && stationInfoParams.touched.dataFormat && stationInfoParams.errors.dataFormat}</span>
            </Grid>
            <Grid row className={stationInfoParams.values.dataSubject === '' ? 'hideRow' : ''} style={{paddingBottom: '10px'}} desktop={{ col: 6 }}>
                <div className='last-div'><label htmlFor='selectedStations' className='font-sans-md text-bold'>Selected Station(s) <span className='required'>Required</span>
                    <div className='searchStationsDownloadPage'>
                        <i className="fas fa-search" />
                        <ScrollCtx.Provider value ={{scrollTopRef, restoreToken}}>

                            <Autocomplete
                                disableCloseOnSelect
                                multiple
                                noOptionsText={
                                    <div className='no-results'>
                                        <div>No results match your search criteria.</div>
                                        <div><b>Here are a few tips:</b></div>
                                        <div>• Remember to check your spelling<br />
                                            • Ensure you are searching either a Station Name or Station ID number</div>
                                    </div>
                                }
                                className="dataDownload"
                                inputValue={inputValue}
                                fullWidth
                                onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'input') {
                                    setInputValue(newInputValue);
                            
                                    const search = newInputValue.toLowerCase();
                                    const filtered = stationInfoParams?.stationsForSearch.filter((station:any) => {
                                    if (search.length <= 2 && search.length !== 0) {
                                        return station.state?.toLowerCase().includes(search);
                                    }
                                    return (
                                        station.station_name?.toLowerCase().includes(search) ||
                                        station.network_name?.toLowerCase().includes(search) ||
                                        station.state?.toLowerCase().includes(search)
                                    );
                                    });
                            
                                    if(stationInfoParams?.currSelectedStations?.length>0){
                                        setFilteredStations([...stationInfoParams.currSelectedStations, ...filtered]);
                                    }
                                    else{
                                        setFilteredStations(filtered);
                                    }                                }
                                }}
                                onChange={(e, value) => {
                                    const isSelectAllCurrentlyChecked = selectAllChecked;
                                    const isSelectAllStillSelected = value.some((item) => item.value === 'select-all');
                                    const isFiltered = inputValue.trim().length > 0;                             
                                    const stationsToSelect = isFiltered ? filteredStations : stationInfoParams?.stationsForSearch;
                                    if (isSelectAllCurrentlyChecked && !isSelectAllStillSelected) {
                                    stationInfoParams.handleSearch(e, []);
                                    setSelectAllChecked(false);
                                    return;
                                    }
                                    if (!isSelectAllCurrentlyChecked && isSelectAllStillSelected) {
                                    const allWithSelectAll = [...stationsToSelect];
                                    if (!isFiltered) {
                                        allWithSelectAll.unshift({
                                        station_name: 'Select All',
                                        network_name: 'Select All',
                                        value: 'select-all',
                                        search_name: 'Select All',
                                        });
                                    }
                                    stationInfoParams.handleSearch(e, allWithSelectAll);
                                    setSelectAllChecked(!isFiltered);
                                    setInputValue('');
                                    setFilteredStations(stationInfoParams?.stationsForSearch);
                                    return;
                                    }
                                    if (isSelectAllCurrentlyChecked && isSelectAllStillSelected) {
                                    stationInfoParams.handleSearch(e, value);
                                    setSelectAllChecked(false);
                                    return;
                                    }
                                    stationInfoParams.handleSearch(e, value);                           
                                    const allSelected = value.length === stationInfoParams?.stationsForSearch.length;
                                    const noFilter = inputValue.trim().length === 0;
                                    setSelectAllChecked(allSelected && noFilter);
                                    setRestoreToken((t)=> t+1)
                                }}
                                value={stationInfoParams.valsFromSearch}
                                id="selectedStations"
                                onBlur={() => setFieldTouched('dataSelectedStations')}
                                options={stationInfoParams?.stationsForSearch? [{station_name:'Select All', network_name: 'Select All', value: 'select-all',search_name: 'Select All', type: `${values.dataTimeIncrements}`, download:`weather`},...stationInfoParams.stationsForSearch]:[]}
                                renderOption={
                                    (props, option)=>(
                                    <li {...props} key={option.search_name} value={option} id={option}>
                                        {option.search_name}
                                    </li>
                                )}
                                isOptionEqualToValue={(option,value)=>option?.search_name===value?.search_name}
                                getOptionLabel={(option)=>`${option.search_name}`}
                                filterOptions={(options, {inputValue})=>{
                                    const search = inputValue.toLowerCase();
                                    if(search.length<=2 && search.length!==0){
                                        return options.filter((option)=>
                                            option.state?.toLowerCase().includes(search) || 
                                            option.station_name==='Select All' ||
                                            option.station_id.toString().includes(search)
                                        )
                                    }
                                    return options.filter((option)=>
                                        option.station_name?.toLowerCase().includes(search) ||
                                        option.network_name?.toLowerCase().includes(search) ||
                                        option.state?.toLowerCase().includes(search) ||
                                        option.station_name==='Select All' ||
                                        option.station_id.toString().includes(search)

                                    )
                                }}   
                                ListboxComponent={VirtualizedListBox}               
                                renderInput={(params) => (
                                    <TextField
                                        placeholder='Search All Stations...'
                                        className="dataDownload"
                                        aria-label={'Search Station...'}
                                        data-testid={'search-bar'}
                                        {...params}
                                        InputProps={{
                                            ...params.InputProps,
                                            type: 'search',
                                        }}
                                        helperText={!!touched.dataSelectedStations && !!errors.dataSelectedStations ? errors.dataSelectedStations : ''}
                                        fullWidth
                                        FormHelperTextProps={{
                                            tabIndex: 0
                                        }}
                                        aria-errormessage='Station(s) are required'
                                        onBlur={() => setFieldTouched('dataSelectedStations')}
                                        error={!!touched.dataSelectedStations && !!errors.dataSelectedStations}
                                    />
                                )}
                            />
                        </ScrollCtx.Provider>
                    </div>
                    </label>
                </div>
                {
                      
                      selectAllChecked ? (
                        <div className={values.dataSelectedStations ? 'selectedStations' : 'hideRow'}>
                            <div> {`All stations have been selected. Total stations selected: ${stationInfoParams.currSelectedStations?.length-1}`}</div>
                            <div><button type='button' onClick={stationInfoParams.clearSelected}>Clear All</button></div>

                        </div>
                        ): (
                          <div className={values.dataSelectedStations ? 'selectedStations' : 'hideRow'}>
                          <div>{`These are your selected stations. Total stations selected: ${stationInfoParams.currSelectedStations?.length}`}</div>
                          <div className="smooth-scrollbar" style={{maxHeight: '400px', border: '1px solid #717171', width: '75vw',padding: '3px', borderRadius:'5px'}}>
                              {
                            stationInfoParams.currSelectedStations.map((station) =>
                                <Chip 
                                    label={`${station.station_name}, ${station.network_name}, ${station.state}, ${station.station_id}`}
                                    key={station.station_id} 
                                    onDelete={() => stationInfoParams.handleDelete(station.station_id)} 
                                    onKeyDown={(event)=>{event.key==="Backspace" && stationInfoParams.handleDelete(station.station_id) }}
                                    variant="outlined" 
                                    deleteIcon={<CloseIcon tabIndex={0} onKeyDown={(event) => { event.key==='Enter' && stationInfoParams.handleDelete(station.station_id)}}/>} 
                                />
                                        )

                                    }
                                </div>
                                <div><button type='button' onClick={clearSelected}>Clear All</button></div>
                            </div>  
                            )
                        }
            </Grid>            
        </div>
    )
}
